import { useContext, useState, useEffect } from "react";
import { LoginContext } from "../context/LoginContext.jsx";
import { useNavigate } from "react-router-dom";
import Axios from "axios";
import Loading from "../components/Loadingg.jsx";
import './css/login.css'
import  logoHest  from '../assets/logoHest.png'
import { baseURL } from '../service/api.jsx';


export default function Login() {
    const { setIsLogged, setAtivoAdm, setIdFuncionario, database, setDataBase, setNomeEmpresa, setNomeFuncionario } = useContext(LoginContext);
    const [ usuario, setUsuario ] = useState("");
    const [ senha, setSenha ] = useState("");    
    const [ removeLoading, setRemoveLoading ] = useState(true);
    const [ modalOpen, setModalOpen ] = useState(false);
    const [ modalMessage, setModalMessage ] = useState("");
    const navigate = useNavigate();
    
    useEffect(() => {
    const jaMostrou = localStorage.getItem("alertLoginMostrado");

    if (!jaMostrou) {
        alert(
        "=== Dados de Acesso ===\n\n" +
        "Empresa: Hest\n" +
        "Usuário: teste\n" +
        "Senha: 123\n\n"
        );

        localStorage.setItem("alertLoginMostrado", "true");
    }
    }, []);


    function getCompany(idEmpresa){
        Axios.post(`${baseURL}/company/getCompany`, {
                idEmpresa: idEmpresa,            
                database: database
        }).then((response) => {    
            if (response.data[0].nomeEmpresa) {
                setNomeEmpresa(response.data[0].nomeEmpresa);  
            }
        }).catch((error) => {
            console.error('Erro ao fazer login:', error);
            setModalMessage(error.response?.data?.message || 'Erro ao buscar dados da empresa.');
            setModalOpen(true);
        }).finally(() => {
            setRemoveLoading(true);
        });
    }

    const logar = () => {
        sessionStorage.setItem('database', database);  
        // setUsuario('admin');
        // setSenha('123');        
        if (usuario !== '' && senha !== '' && sessionStorage.getItem("database") !== null) {
            setRemoveLoading(false);                        
            Axios.post(`${baseURL}/users/login`, {
                name: usuario,
                senha: senha,
                database: sessionStorage.getItem("database")
            }).then((response) => {                    
                if (response.data && response.data[0]) {
                        
                    let user = response.data[0];
                    let ativoFuncionario = user.ativoFuncionario;
                    
                    if (ativoFuncionario) {                       
                        /* Buscando dados da empresa cadastrada */ 
                        getCompany(1);
                        /* Consumindo dados do usuário */ 
                        const nomeFuncionario = user.nomeFuncionario;                                            
                        let ativoAdm = user.ativoAdm;                    
                        let idFuncionario = user.idFuncionario;
                        setNomeFuncionario(nomeFuncionario);
                        setIdFuncionario(idFuncionario);                    
                        setAtivoAdm(ativoAdm);
                        setIsLogged(true);
                        navigate('/home');
                    } else {
                        setModalMessage('Acesso negado');
                        setModalOpen(true);
                    }
                } else {
                    setModalMessage('Usuário ou senha incorretos.');
                    setModalOpen(true);
                }
            }).catch((error) => {
                console.error('Erro ao fazer login:', error);
                setModalMessage(error.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.');
                setModalOpen(true);
            }).finally(() => {
                setRemoveLoading(true);
            });
        } else {
            setModalMessage('Preencha seu usuário e senha para continuar.');
            setModalOpen(true);
        }
    };
    

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === "Enter") {
                logar();
            }
        };

        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [usuario, senha]);

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            <div className="mainLogin">            
                <div className=" loginContainer ">
                    <img className="logoHest" src={logoHest} alt="" />
                    <div className="divInput">
                    { removeLoading ?
                        <input
                            type="text"
                            name="name"
                            placeholder="Digite 'Hest'"
                            onChange={(e) => {
                                setDataBase(e.target.value);
                            }}
                            className="input"
                        /> : '' }
                    </div>
                    <div className="divInput">
                    { removeLoading ?
                        <input
                            type="text"
                            name="name"
                            placeholder="Digite 'teste'"
                            onChange={(e) => {
                                setUsuario(e.target.value);
                            }}
                            className="input"
                        /> : '' }
                    </div>                    
                    <div className="divInput">
                      { removeLoading ?
                        <input
                            type="password"
                            name="senha"
                            placeholder="Digite '123"
                            onChange={(e) => {
                                setSenha(e.target.value);
                            }}
                            className="input"
                        /> : '' }
                    </div>
                    { removeLoading ?
                        <div className="divButtonEntrar">
                        <button
                            onClick={() => logar()}
                            className="buttonEntrar"
                        >
                            {removeLoading ? "Entrar" : "Carregando..."}
                        </button>
                    </div> 
                        : ''} 
                    {!removeLoading && <Loading />}
                    <p className="version">v1.0.0</p>
                    <p className="lasoft">L.A.</p>
                </div>
                
            </div>
            
            {modalOpen && (
                <div className="fixed inset-0 flex items-center justify-center">
                    <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={closeModal}></div>
                    <div className="bg-white p-8 rounded-lg shadow-md max-w-md transform transition-all">
                        <p className="text-lg text-gray-800">{modalMessage}</p>
                        <div className="mt-4 flex justify-center">
                            <button
                                onClick={closeModal}
                                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
